import React from 'react';
import Icon from '../../../components/AppIcon';

const PerformanceMetrics = ({ vessel, performanceData }) => {
  const metrics = [
    {
      id: 'fuel_efficiency',
      label: 'Fuel Efficiency',
      value: performanceData?.fuelEfficiency,
      unit: 'MT/day',
      change: -2.3,
      icon: 'Fuel',
      color: 'success'
    },
    {
      id: 'cii_rating',
      label: 'CII Rating',
      value: performanceData?.ciiRating,
      unit: '',
      change: 0.1,
      icon: 'Award',
      color: performanceData?.ciiRating === 'A' ? 'success' : performanceData?.ciiRating === 'B' ? 'warning' : 'error'
    },
    {
      id: 'emissions_intensity',
      label: 'Emissions Intensity',
      value: performanceData?.emissionsIntensity,
      unit: 'gCO₂/t·nm',
      change: -1.8,
      icon: 'CloudRain',
      color: 'accent'
    },
    {
      id: 'speed_optimization',
      label: 'Speed Optimization',
      value: performanceData?.speedOptimization,
      unit: '%',
      change: 3.2,
      icon: 'Gauge',
      color: 'primary'
    }
  ];

  const getColorClasses = (color) => {
    switch (color) {
      case 'success':
        return 'text-success bg-success/10';
      case 'warning':
        return 'text-warning bg-warning/10';
      case 'error':
        return 'text-error bg-error/10';
      case 'accent':
        return 'text-accent bg-accent/10';
      default:
        return 'text-primary bg-primary/10';
    }
  };

  const getChangeColor = (change) => {
    if (change > 0) return 'text-success';
    if (change < 0) return 'text-error';
    return 'text-muted-foreground';
  };

  return (
    <div className="bg-card rounded-lg border p-6 shadow-maritime-sm">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-semibold text-foreground">Performance Metrics</h3>
          <p className="text-sm text-muted-foreground">Real-time vessel performance indicators</p>
        </div>
        <div className="flex items-center space-x-2">
          <div className="w-2 h-2 bg-success rounded-full animate-pulse"></div>
          <span className="text-xs text-muted-foreground">Live data</span>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {metrics?.map((metric) => (
          <div key={metric?.id} className="p-4 rounded-lg border bg-background">
            <div className="flex items-center justify-between mb-3">
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${getColorClasses(metric?.color)}`}>
                <Icon name={metric?.icon} size={20} strokeWidth={2} />
              </div>
              {metric?.change !== undefined && (
                <div className={`flex items-center space-x-1 ${getChangeColor(metric?.change)}`}>
                  <Icon 
                    name={metric?.change > 0 ? 'TrendingUp' : 'TrendingDown'} 
                    size={14} 
                    strokeWidth={2} 
                  />
                  <span className="text-xs font-medium">
                    {Math.abs(metric?.change)}%
                  </span>
                </div>
              )}
            </div>
            
            <div className="space-y-1">
              <div className="flex items-baseline space-x-1">
                <span className="text-2xl font-bold text-foreground">
                  {metric?.value}
                </span>
                {metric?.unit && (
                  <span className="text-sm text-muted-foreground">
                    {metric?.unit}
                  </span>
                )}
              </div>
              <p className="text-sm text-muted-foreground">
                {metric?.label}
              </p>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 p-4 bg-muted/50 rounded-lg">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <Icon name="Info" size={16} className="text-accent" strokeWidth={2} />
            <span className="text-sm text-foreground">
              Performance data updated every 15 minutes from IoT sensors
            </span>
          </div>
          <button className="text-sm text-accent hover:text-accent/80 transition-maritime">
            View detailed breakdown
          </button>
        </div>
      </div>
    </div>
  );
};

export default PerformanceMetrics;